import DashboardProformaInvoice from "./DashboardProformaInvoice.vue";
import ProformaInvoiceCreated from "./ProformaInvoiceCreated.vue";
import ProformaInvoicePosting from "./ProformaInvoicePosting.vue";
import ProformaInvoiceCreate from "./ProformaInvoiceCreate.vue";
import ProformaInvoicePrinted from "./ProformaInvoicePrinted.vue";

import routesTemplateSetting from "./templateSetting/routes";
import routesCustomerList from "./customer-list/routes";
import routesProformaRental from "./proforma-rental/routes";
import PIIndex from './Index.vue'

import CustomerFileUpload from "./CustomerFileUpload.vue";
let routesProformaInvoice= [
      {
        path: '',
        meta: {
          title: "Chain System",
        },
        name: "DashboardProformaInvoice",
        component: DashboardProformaInvoice
      },
      {
        path: 'created',
        meta: {
          title: "Chain System",
        },
        name: "ProformaInvoiceCreated",
        component: ProformaInvoiceCreated
      },
      {
        path: 'add/:id',
        meta: {
          title: "Chain System",
        },
        name: "ProformaInvoiceCreate",
        component: ProformaInvoiceCreate
      },
      {
        path: 'add',
        meta: {
          title: "Chain System",
        },
        name: "ProformaInvoiceCreate",
        component: ProformaInvoiceCreate
      },
      {
        path: 'post',
        meta: {
          title: "Chain System",
        },
        name: "ProformaInvoicePosting",
        component: ProformaInvoicePosting
      },
      
      {
        path: 'print',
        meta: {
          title: "Chain System",
        },
        name: "ProformaInvoicePrinted",
        component: ProformaInvoicePrinted
      },

      {
        path: "template-setting",
        meta: {
          title: "Chain System",
        },
        children: routesTemplateSetting,
        component: PIIndex,
      },

      {
        path: "customer-list",
        meta: {
          title: "Chain System",
        },
        children: routesCustomerList,
        component: PIIndex,
      },

      {
        path: "proforma-rental",
        meta: {
          title: "Chain System",
        },
        children: routesProformaRental,
        component: PIIndex,
      },
    {
        path: 'upload-file',
        meta: {
          title: "Chain System",
        },
        name: "CustomerFileUpload",
        component: CustomerFileUpload
      },

      // {
      //   path: 'customer-list',
      //   meta: {
      //     title: "Chain System",
      //   },
      //   name: "CustomerList",
      //   component: CustomerList
      // },
]

export default routesProformaInvoice
  